import { IAuthService_TYPE } from '@shared/Core/Services/IAuthService';
import { useService } from '../../../Hooks/useService';
import FirebaseAuthService from '../services/FirebaseAuthService';

export function useAuthService() {
    return useService<FirebaseAuthService>(IAuthService_TYPE);
}
